export async function generateUint8Array(img: File): Promise<Uint8Array> {
  try {
    const buffer = await img.arrayBuffer()
    return new Uint8Array(buffer)
  } catch (e: unknown) {
    console.error((e as Error).message)
    throw e
  }
}
